/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Method/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Delete from './Delete/index'
import Details from './Details/index'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Method({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let paymentTokenIdValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'token_id',
})
let reusableMethodIdValueData = fromData.useDataValue({ viewPath,
context: 'reusable_method',
path: 'id',
})
let aggregateData = fromAggregate.equals(paymentTokenIdValueData, reusableMethodIdValueData)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let paymentTokenIdValueData1 = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'token_id',
})
let reusableMethodIdValueData1 = fromData.useDataValue({ viewPath,
context: 'reusable_method',
path: 'id',
})
let aggregateData1 = fromAggregate.equals(paymentTokenIdValueData1, reusableMethodIdValueData1)
  return (<React.Fragment
>
<div
  data-testid="Method.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z2lYuxF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Method.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-2-Z2lYuxF': dtColorsWhite,'--bc-3-Z2lYuxF': dtColorsNeutral200,'--pl-4-Z2lYuxF': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-5-Z2lYuxF': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--c-6-Z2lYuxF': aggregateData ? "default" : "pointer"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Method.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Method.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Details
  viewPath={`${viewPath}/Details`}
/>
</div>
<Radial
  viewPath={`${viewPath}/Radial`}
 marginRight={-8}
 paddingRight={0}
 data="payment.token_id"
 data="reusable_method.id"
 aggregate="/Simple/Data/aggregate.js equals"
 isSelected={aggregateData1}
/>
</div>
</div>
<div
  data-testid="Method.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
</div>
</div>
{children}
</React.Fragment>)
}